// extracted by css-extract-rspack-plugin
export default {"wrapper":"AdditionalRegionsModal-module__wrapper--WAvrD","item":"AdditionalRegionsModal-module__item--Ur9PF"};